/**
 * Create/set cookie value
 * @param {string} cookieName	name of the cookie
 * @param {string} value		value
 * @param {Date} [expireDate]	optional expiration date
 */
export function createCookie(cookieName, value, expireDate) {
	let cookie;
	if(expireDate) cookie=cookieName+"="+value+";expires="+expireDate;
	else cookie=cookieName+"="+value;
	document.cookie=cookie;
}

/**
 * Get value of a cookie or null if the cookie isn't set
 * @param {string} cookieName	name of the cookie
 * @returns {string}			cookie value
 */
export function getCookieVal(cookieName)
{
	const cookies = document.cookie.split("; ");
	for (let c of cookies) {
		const cparts = c.split("=");
		if (cookieName === cparts[0]) return cparts[1];
	}
	return null;
}

/**
 * Set value of an field (input element) from stored cookie
 * @param {string} cookieId		name of the cookie
 * @param {string} field		id of target element
 */
export function initValueFromCookie(cookieId, field)
{
	const value = getCookieVal(cookieId);
	if(value != null && value !== '') {
		const el = document.getElementById(field);
		if(el) el.value = value;
	}
}
